import { Text, Box, Notice } from 'braid-design-system';
import React from 'react';

interface Props {
  text: string;
  isError?: boolean;
}
const SaveMessage = ({ text, isError = false }: Props): JSX.Element => (
  <Box display="flex">
    <Notice tone={isError ? 'critical' : 'positive'}>
      <Text>{text}</Text>
    </Notice>
  </Box>
);

export default SaveMessage;
